import classNames from 'classnames';

import { ButtonCoreAppearance, ButtonCoreSize, ButtonCoreVariant } from './button-core.types';

const baseStyles = 'flex items-center justify-center rounded transition-colors duration-200 focus:outline-none';

const sizeStyles: Record<ButtonCoreSize, string> = {
  s: 'px-4 py-2 text-action-button-s',
  m: 'px-8 py-3 text-action-button-m',
};

const variantStyles: Record<ButtonCoreVariant, Record<ButtonCoreAppearance, string>> = {
  primary: {
    filled: 'fill-dark text-negative focus:fill-dark-active disabled:fill-dark-disabled disabled:text-disabled',
    outline: 'fill-dark text-negative focus:fill-dark-active disabled:fill-dark-disabled disabled:text-disabled',
  },
  secondary: {
    filled:
      'fill-tertiary text-primary focus:fill-tertiary-active disabled:fill-tertiary-disabled disabled:text-disabled',
    outline:
      'border border-hard text-primary hover:border-medium hover:text-secondary focus:border-medium focus:text-secondary disabled:fill-tertiary disabled:text-disabled',
  },
  'accent-primary': {
    filled:
      'fill-accent-primary text-white focus:fill-accent-primary-active disabled:fill-accent-primary-disabled disabled:text-disabled',
    outline:
      'fill-accent-primary text-white focus:fill-accent-primary-active disabled:fill-accent-primary-disabled disabled:text-disabled',
  },
  'accent-secondary': {
    filled:
      'fill-accent-secondary text-accent focus:fill-accent-secondary-active disabled:fill-accent-secondary-disabled  disabled:text-accent-disabled ',
    outline: 'border border-accent-primary text-accent disabled:text-accent-disabled',
  },
  critical: {
    filled: 'fill-critical text-white focus:critical-active disabled:fill-critical-disabled  disabled:text-disabled',
    outline:
      'border border-critical-no-bg text-critical-no-bg hover:fill-critical hover:text-white focus:fill-critical-active focus:text-white disabled:bg-transparent disabled:border-critical-soft disabled:text-critical-disabled',
  },
  warning: {
    filled: 'fill-warning text-white focus:fill-warning-active disabled:fill-warning-disabled disabled:text-disabled',
    outline:
      'border border-warning-no-bg text-warning-no-bg hover:fill-warning hover:text-white focus:fill-warning-active focus:text-white disabled:bg-transparent disabled:border-warning-soft disabled:text-warning-no-bg',
  },
};

export function getButtonCoreStyles(
  variant: ButtonCoreVariant = 'primary',
  appearance: ButtonCoreAppearance = 'filled',
  size: ButtonCoreSize = 'm',
  fullWidth: boolean = false
): string {
  return classNames(baseStyles, sizeStyles[size], variantStyles[variant][appearance], fullWidth ? 'w-full' : 'w-max');
}
